import React from 'react';

type Props = {
  count: number;
};

const SummaryCard: React.FC<Props> = ({ count }) => {
  return (
    // bg-white px-6 py-4 shadow-none border-none
    // bg-white shadow-md rounded-2xl p-6 text-center border border-gray-200
    <div className="bg-white px-6 py-4 shadow-none border-none text-center">
  
      <h2 className="text-gray-600 text-sm mb-2">サジェストキーワード数</h2>
      <p className="text-4xl font-bold text-blue-600">{count.toLocaleString()}</p>
    </div>
  );
};

export default SummaryCard;
